<template>
  <QuickBetDetail />
</template>

<script>
import LoadingSkeleton from '@/components/generic/LoadingSkeleton'

const QuickBetDetail = () => ({
  component: import('@/components/center_widgets/QuickBetDetail'),
  loading: LoadingSkeleton,
  timeout: 200,
})

export default {
  name: 'QBetPage',
  components: { QuickBetDetail },
}
</script>
